__turbopack_context__.v({
  "bars": "Histogram-module__he_wSq__bars",
  "layer": "Histogram-module__he_wSq__layer",
  "wrap": "Histogram-module__he_wSq__wrap",
});
